<svg 
  [attr.width]="gaugeSize" 
  [attr.height]="gaugeSize * 0.65" 
  [attr.viewBox]="'0 0 ' + gaugeSize + ' ' + (gaugeSize * 0.65)"
  class="gauge-svg">
  
  <!-- Background track -->
  <path 
    [attr.d]="backgroundPath"
    [attr.stroke]="backgroundStroke"
    [attr.stroke-width]="strokeWidth"
    fill="none"
    stroke-linecap="butt"
    class="gauge-background" />
  
  <!-- Colored zones -->
  <ng-container *ngFor="let arc of arcs">
    <path 
      [attr.d]="arc.path"
      [attr.stroke]="arc.color"
      [attr.stroke-width]="strokeWidth"
      fill="none"
      stroke-linecap="butt"
      class="gauge-arc" />
  </ng-container>
</svg>
